import qs from 'qs';
import _ from 'lodash';
import { alphabeticalSort } from '../../../utilities/data';
import { AlertTemplatesRequest } from '@tradingblock/types';

export const alertRequestToQueryString = (request: AlertTemplatesRequest) =>
  qs.stringify(request, { indices: false, sort: alphabeticalSort });

export const alertRequestKey = (request: AlertTemplatesRequest) => alertRequestToQueryString({ ...request });
